import React from "react";
import Box from "@mui/material/Box";

import SearchScanner from "../capture/SearchScanner";
import TableSearch from "../TablePro/TableSearch";

export default function Search({ search, setSearch, loading, receivingWizard }) {
  if (receivingWizard) {
    return (
      <Box minWidth={{ sm: 400 }} bgcolor="white" borderRadius={4}>
        <SearchScanner
          search={search}
          setSearch={setSearch}
          showNAButton={false}
        />
      </Box>
    );
  }

  return (
    <TableSearch
      placeholder="Search assets"
      disabled={loading}
      onChange={setSearch}
      value={search}
    />
  );
}
